export default __webpack_public_path__ + "static/media/ChevronUp.c1b397f5.svg";